export default {
    navBar: {
        home: 'Home',
        movers: 'Più attivi', // Movers
        signals: 'Dinamicità', // Momentum (Segnali di momentum)
        myWatchlist: 'Lista Preferiti', // Watchlist (IT: Lista di Osservazione)
        calendars: 'Calendari',
        settings: 'Impostazioni',
        socialBuzz: 'Tendenza Social', // Trending
        sectors: 'Settori',
        stocksFeed: 'Mio Feed News', // My newsfeed (IT: Notizie Personalizzate)
        macroFeed: 'News Mercato', // Market news
        top10: 'Top 10',
        dividends: 'Dividendi',
        top10Pro: 'Andamento Mercato', // Market performance
        indices: 'Composizione Indici', // Indices holdings
        institutional: 'Posizioni Istituzionali', // Institutional holdings (IT: Partecipazioni Istituzionali)
        contactUs: 'Contattaci',
        termsOfUse: 'Termini di Utilizzo',
        selectLanguage: 'Seleziona Lingua Sistema', // Select system's language
        heatmap: 'Mappa Termica', // Heatmap
        new: 'Novità', // New (Shorthand: N.)
        soon: 'Prossimamente' // Soon (Shorthand: Pross.)
    },
    signals: {
        lowhigh: 'Min/Max 52 Settimane', // 52 weeks low/high
      low52: 'Min 52', // 52 low
      high52: 'Max 52', // 52 high
        ath: 'Massimo Storico', // All time high
        note: 'Basato sull\'ultimo giorno di negoziazione' // Based on the last trading day
    },
    contactUs: {
        title: 'Contattaci',
        text: 'Ci impegniamo a fornirti le informazioni più pertinenti e di alta qualità nel più breve tempo possibile. Accettiamo volentieri idee, suggerimenti per miglioramenti o segnalazioni di bug.',
        name: 'Nome',
        email: 'Email',
        message: 'Messaggio',
        privacy: 'La tua privacy è importante per noi. Le informazioni sono intese a rispondere alla tua richiesta e non saranno trasferite a terzi o utilizzate per inviare spam.'
    },
    errors: {
        noContentMessage: 'Si prega di scrivere un messaggio', // Please write down a message
        invalidEmail: 'Si prega di digitare un indirizzo email valido', // Please type a valid email address
        emptyCalendar: 'Non ci sono eventi per il periodo selezionato', // There are no events for the selected period
        emptyWatchlist: 'La lista preferiti è vuota', // The watchlist is empty
        emptyFavoriteList: 'La lista preferiti è vuota' // The favorites list is empty (can reuse the key)

    },
    login: {
        trialEnded: {
            title: 'La tua prova gratuita EZtrade è terminata', // Your EZtrade trial has ended
            explain: (price) => `<b>Grazie per aver provato la nostra piattaforma!</b>
              <br/>Per non perdere fantastiche opportunità di mercato, attiva il tuo account Premium per soli $${price}/mese.<br/>
              Se hai problemi o domande, non esitare a contattarci <a class="mbpLink" href="mailto:hello@EZtrade">hello@EZtrade</a>.`,
            signupButton: 'Iscriviti per l\'abbonamento' // Signup for subscription
        }
    },
    languages: {
         en: 'Inglese', // English
        he: 'Ebraico', // Hebrew
    it: 'Italiano', // Italiano
    ar: 'Arabo', // Arabic
    },
    watchlist: {
        numberOfSymbols: 'Numero di simboli', // Number of symbols
        removeSymbols: 'Rimuovi selezionati' // Remove selected
    },
    filters: {
        filterList: 'Filtra Lista', // Filter list
        index: 'Indice',
        sector: 'Settore',
        industry: 'Industria',
        sectors: 'Settori',
        industries: 'Industrie',
        searchType: '(Puoi digitare e cercare)', // (You can type and search)
        pe: 'P/E', // P/E
        marketCap: 'Cap. di Mercato', // Market cap. (Shorthand: Cap. Mkt)
        priceChange: 'Variazione Prezzo', // Price change
        moreThan: 'Maggiore di', // More than
        lessThan: 'Minore di', // Less then
        andMore: 'e superiore', // and above
        andLess: 'e inferiore', // and less
        years: 'anni', // years
        typeAndEnter: 'Digitazione libera (premi Invio per terminare)', // Free typing (press Enter to end)
        dividendConsecutiveYears: 'Anni consecutivi di div. erogati', // Consecutive years of div. payout
        dividendPayoutRatio: 'Rapporto di distribuzione (Payout)', // Dividend payout ratio
        dividendYield: 'Rendimento da dividendo', // Dividend yield
        dividendFrequency: 'Frequenza dividendi', // Dividend frequency
        dividendFrequencyList: [{
            label: 'Trimestrale', // Quarterly
            value: 'quarterly'
        }, {
            label: 'Semestrale', // Semi-yearly
            value: 'semiYearly'
        }, {
            label: 'Annuale', // Yearly
            value: 'yearly'
        }],
        marketCapsList: [
            {
                label: 'Micro-Cap ( < $250M)',
                value: 'microCap'
            },
            {
                label: 'Small-Cap ($250M - $2B)',
                value: 'smallCap'
            },
            {
                label: 'Mid-Cap ($2B - $10B)',
                value: 'midCap'
            },
            {
                label: 'Large-Cap ($10B - $200B)',
                value: 'largeCap'
            },
            {
                label: 'Mega-Cap ( > $200B)',
                value: 'megaCap'
            }
        ],
        select: 'Seleziona',
        seeNews: 'Vedi News filtrate', // See filtered news
        newFilter: 'Torna al Filtro', // Back to filter
        resetFilter: 'Azzera Filtro', // Reset filter
        applyFilter: 'Applica Filtro', // Apply filter
        closeFilter: 'Chiudi', // Close
        results: 'Risultati',
        fount: 'trovati', // found
        symbol: 'Simbolo',
        periods: [
            { value: '1D', label: '1G' }, // 1D (Giorno)
            { value: '5D', label: '5G' }, // 5D
            { value: '1M', label: '1M' }, // 1M (Mese)
            { value: '6M', label: '6M' }, // 6M
            { value: 'YTD', label: 'YTD' }, // YTD (Da Inizio Anno)
            { value: '1Y', label: '1A' }, // 1Y (Anno)
            { value: '3Y', label: '3A' } // 3Y
        ],
    },
    search: {
        tabs: {
            freeSearch: 'Ricerca Libera', // Free search
            filter: 'Filtra per parametri', // Filter by parameters
            trending: 'Simboli in Tendenza' // Trending symbols
        },
        filter: {
            name: 'Nome',
            price: 'Prezzo',
            mustSelectASector: 'Devi selezionare un settore o un\'industria. Puoi cercare un\'industria digitando.', // You must select a sector or an industry...
            sectorSelection: 'Selezione Settore', // Sector selection
            industrySelection: 'Selezione Industrie (puoi digitare e cercare)', // Industries selection
            marketCapSelection: 'Selezione Cap. Mkt.', // Market Cap. selection
            priceChange: 'Variazione Prezzo', // Price change
            moreThan: 'Maggiore di', // More than
            lessThan: 'Minore di', // Less than
            search: 'Filtra', // Filter
            pe: 'P/E',
            seeNews: 'Vedi News filtrate', // See filtered news
            newFilter: 'Torna al Filtro', // Back to filter
            resetFilter: 'Azzera Filtro', // Reset filter
            results: 'Risultati',
            fount: 'trovati', // found
            symbol: 'Simbolo',
            periods: [
                { value: '1D', label: '1G' },
                { value: '5D', label: '5G' },
                { value: '1M', label: '1M' },
                { value: '6M', label: '6M' },
                { value: 'YTD', label: 'YTD' },
                { value: '1Y', label: '1A' },
                { value: '3Y', label: '3A' }
            ],
            sector: 'Settore',
            industry: 'Industria',
            marketCap: 'Cap. di Mercato', // Market cap.
            marketCapRangeValues: [
                { value: '<500m', label: 'Sotto $500M' }, // Under $500M
                { value: '500m-1b', label: '$500M-$1B' },
                { value: '1b-10b', label: '$1B-$10B' },
                { value: '10b-200b', label: '$10B-$200B' },
                { value: '>200b', label: 'Sopra $200B' } // Above $200B
            ],
            marketCapValues: [
                { value: '<10m', label: 'Sotto $10M' },
                { value: '>10m', label: 'Sopra $10M' },
                { value: '>100m', label: 'Sopra $100M' },
                { value: '>1b', label: 'Sopra $1B' },
                { value: '>10b', label: 'Sopra $10B' },
                { value: '>100b', label: 'Sopra $100B' }
            ],
            performance: 'Performance',
        }
    },
    tags: {
        quickLook: 'Riepilogo', // Quick look
        close: 'Chiudi',
        topGainers: 'I Più Guadanati', // Top gainers
        topActive: 'I Più Attivi', // Top active
        topLosers: 'I Più Perdenti', // Top losers
        moreSymbols: 'Altro', // More
        tradingHalt: 'Sospensione Trading', // Trading halt
        tradingResumption: 'Ripresa Trading', // Trading resumption
        signal: 'Segnale',
        trade: 'Operazione', // Trade (IT: Transazione)
        taReview: 'Analisi Tecnica', // Technical review
        moreEvents: 'Altri Eventi', // More events
        hideSymbols: 'Nascondi', // Hide
        insiders: 'Operazioni Insider', // Insider's trade
        pressRelease: 'Comunicato Stampa', // Press release
        shouldKnowNotificationTitle: 'Dovresti Sapere', // You should know
        marketOpen: 'Mercato Aperto', // The market is open
        marketClose: 'Mercato Chiuso', // The market is closed
        preMarket: 'Pre-Mercato', // Pre-market
        postMarket: 'Post-Mercato' // Post-market
    },
    buttons: {
        continueToApp: 'Torna a EZtrade', // Back to EZtrade
        close: 'Chiudi',
        send: 'Invia',
        en: 'Inglese', // English
        he: 'Ebraico', // Hebrew
        filterStocks: 'Filtra Azioni', // Filter stocks
        editColumns: 'Modifica Colonne', // Edit columns
        seeFullDetails: 'Vedi Dettagli Completi', // See full details
        showMoreInfo: 'Mostra Altre Info', // Show more info
        hideMoreInfo: 'Nascondi Altre Info', // Hide more info
        approveTerms: 'Approvo i termini di servizio', // I approve the terms of service
        moveToPortfolio: 'Clicca qui per aggiungere simboli', // Click here to add symbols
        moveToWatchlist: 'Sposta in Lista Preferiti', // Move to watchlist
        addToPortfolio: 'Aggiungi a Lista Preferiti', // Add to watchlist
        removeFromPortfolio: 'Rimuovi da Lista Preferiti', // Remove from watchlist
        addToPortfolioShort: '+', // +
        removeFromPortfolioShort: '-', // -
        readMore: 'Leggi di più', // Read more
        readLess: 'Leggi di meno' // Read less
    },
    feeds: {
        viewImage: 'Visualizza immagine', // View image
        viewLink: 'Visualizza link', // View link
        stocksFeed: 'Mio Feed News', // My newsfeed
        stocksFavoriteFeed: 'News Preferite', // My favorite newsfeed
        macroFeed: 'News Mercato', // Market news
        backToPortfolio: 'Torna a Lista Preferiti', // Back to watchlist
        filter: 'Filtra News', // Filter news
        breakingNews: 'Ultime News', // Breaking news (IT: Notizie dell'ultima ora)
        wiim: 'Azioni in Movimento', // Stocks on the move
        filters: {
            all: 'Tutto', // All
            tradesAndSignals: 'Operazioni e Segnali', // Trades & signals
            priceTargets: 'Analisti', // Analysts (Price Targets)
            pr: 'Comunicato Stampa', // Press release (Shorthand: C.S.)
            insiders: 'Operazioni Insider', // Insider's trades
            hedgeFunds: 'Hedge Funds',
            earnings: 'Utili', // Earnings (IT: Guadagni/Profitti)
            sec: 'SEC',
            financialMedia: 'Media Finanziari', // Financial media
            analysts: 'BZ Wire' // BZ wire
        }
    },
    tables: {
        symbol: 'Simbolo',
        '1d' : '% Giorno', // Day %
        '5d': '% 5G', // 5D %
        '10d': '% 10G', // 10D %
        '1m': '% 1M', // 1M %
        '6m' : '% 6M', // 6M %
        'q' : '% Trim.', // Quarter % (Shorthand: Trimestre)
        ytd: '% YTD', // YTD %
        '1y' : '% 1A', // 1Y %
        '3y' : '% 3A', // 3Y %
        '5y' : '% 5A', // 5Y %
        sector: 'Settore',
        industry: 'Industria',
        marketCap: 'Cap. Mkt.', // Market cap. (Shorthand)
        pe: 'P/E', // P\E
        nextDividendExDate: 'Data Ex-Div. Succ.', // Next div date (Shorthand: Data Stacco Div. Successiva)
        datePublished: 'Data Pubblicazione', // Date published
        lastUpdate: 'Data Aggiornamento', // Date updated
        numOfFollowups: '# follow-up', // # of followups
    },
    trades: {
        percentChange: '% Variazione', // % change
        percentChangeTooltip: 'Variazione percentuale del prezzo del titolo da quando è stata pubblicata un\'operazione', // Stock's price percent change since a trade was published
        since: 'da', // since
        gained: 'guadagnato', // gained
        lost: 'perso', // lost
        dateAdded: 'Data Pubblicazione', // Publishing date
        lastUpdate: 'Data Aggiornamento', // Update date
        numberOfFollowups: '# follow-up', // # followups
        published: 'Pubblicato', // Published
        updated: 'Aggiornato', // Updated
        daysAgo: 'giorni fa', // days ago
        change: 'Var. %', // Cng. %
        week1: '1 settimana', // 1 week
        week2: '2 settimane', // 2 weeks
        week3: '3 settimane', // 3 weeks
        week4: '4 settimane', // 4 weeks
        week5: '5 settimane', // 5 weeks
        week6: '6 settimane', // 6 weeks
        tradeHasFollowups: (num) => `Questa operazione ha <span class="highlight">${num}</span> follow-up.`, // This trade has [num] followups.
        sinceTradeWasPublished: (symbol) => `Da quando questa operazione è stata pubblicata, il prezzo di <b>${ symbol }</b>`, // Since this trade was published, [symbol]'s price
    },
    messages: {
        followup: 'Follow-up Operazione', // Trade follow up
        enlargeImage: 'Clicca per ingrandire l\'immagine', // Click to enlarge image
        welcomeBanner: 'Benvenuto in EZtrade!', // Weclome to EZtrade!
        languageBanner: 'Scegli la lingua del sistema:', // Please choose system's language:
        topMktCap: 'Questa pagina si riferisce ad aziende con un volume di +150K', // This page refers to companies with a volume of +150K
        topVolume: 'Questa pagina si riferisce ad aziende con un volume pari o superiore a 150K', // This page refers to companies with a volume of 150K and above
        peersExpl: (symbol) => `Azioni che sono state valutate in base a una serie di fattori e hanno una Cap. di Mercato simile a ${symbol}`, // Stocks that have been evaluated...
        shortInstructions: 'EZtrade ti fornisce automaticamente notizie ed eventi del mercato azionario in tempo reale. Per creare il tuo feed di notizie, aggiungi facilmente i simboli alla tua lista preferiti. Puoi aggiungere e rimuovere simboli in qualsiasi momento.', // EZtrade brings you real-time stock market news...
        favoriteInstruction: 'Contrassegna i simboli sulla tua lista preferiti con una stella per creare un feed di notizie mirato', // Mark symbols on your watchlist with a star...
        contactMessageSentTitle: 'Il tuo messaggio è stato inviato!', // Your message has been sent!
        contactUsThankYou: 'Grazie per il tuo messaggio, ti risponderemo a breve', // Thank you for your message, we will respond shortly
        watchlist: 'Cerca i simboli e aggiungili alla tua lista preferiti. Creare una lista preferiti ti permetterà di ricevere notizie ed eventi pertinenti prima di tutti gli altri.', // Search for symbols and add them to your watchlist...
        trendingStocks: 'Azioni molto menzionate sui social media. Le variazioni nel numero di menzioni di un\'azione possono indicare una tendenza in crescita sulle piattaforme social.', // Highly mentioned stocks on social media...
        exDiv: 'Nella data ex-dividendo, il prezzo delle azioni scende dell\'importo del dividendo, e solo chi possiede l\'azione in tale data riceve il dividendo.', // On the ex-dividend date...
        sectors: 'Visualizza la performance dei vari settori di mercato. Cliccando sul nome di un settore puoi visualizzare i simboli che include e ordinarli in base a diversi parametri.' // View the performance of the various market sectors...
    },
    symbolSearch: {
        frequentlySearched: 'Simboli cercati di frequente', // Frequently searched symbols
        inputLabel: 'Cerca Simboli', // Search symbols
        inputLabelNote: 'Puoi cercare più simboli o nomi di titoli separati dallo spazio.', // You can search a number of symbols or equity names seperated by the space key.
        noResults: 'Nessun risultato trovato per' // No results were found for
    },
    settingsPage: {
        titles: {
            title: 'Impostazioni',
            notificationSettings: 'Impostazioni Notifiche', // Notification settings
            userSettings: 'Impostazioni Utente', // User settings
            systemSettings: 'Impostazioni di Sistema', // System settings
            dangerZone: 'Zona di Pericolo', // Danger zone
            subscriptionSettings: 'Impostazioni Abbonamento', // Subscription settings
            languageSettings: 'Impostazioni Lingua', // Language settings
            systemLanguage: 'Lingua di Sistema predefinita', // Default system's language
            newsLanguages: 'Lingue delle News', // News languages
            verifyClosingOfAccount: 'Approva la chiusura dell\'account' // Approve account closing
        },
        buttons: {
            close: 'Chiudi',
            saveLanguageSettings: 'Salva Impostazioni Lingua', // Save language settings
            saveNotifications: 'Salva Impostazioni Notifiche', // Save notification settings
            saveAccount: 'Salva Impostazioni Account', // Save account settings
            closeAccount: 'Chiudi Account', // Close account
            logout: 'Esci da questo account', // Logout this account
            subscribeNow: 'Abbonati subito a EZtrade Premium', // Subscribe to EZtrade premium now
            subscribe: 'Abbonati', // Subscribe
            approveClosingOfAccount: 'Capisco, chiudi l\'account' // I understand, close the account
        },
        tabs: {
            account: 'Account',
            notifications: 'Notifiche',
        },
        notes: {
            dataUpdate: 'Dati aggiornati', // Data was updated
            updatePassword: 'Si prega di aggiornare la password', // Please update password
            account: 'Imposta i dettagli del tuo account e l\'abbonamento. Puoi annullare il tuo account in qualsiasi momento.', // Set you account details and subscription...
            notifications: 'Imposta le notifiche via email. Puoi riceverle in tempo reale, come riepilogo a un orario fisso (se esistono) o disattivarle.', // Set email notifications...
            googleAuth: 'Hai effettuato l\'iscrizione a EZtrade con il tuo account Google. Se cambi il tuo indirizzo Email, non sarai più in grado di accedere utilizzando Google.', // You have signed up to EZtrade with your Google account...
            verifyClosingOfAccount: 'Si prega di approvare la chiusura di questo account. Non sarai più in grado di ricevere notifiche o altri servizi, accedere a questo account e tutti i pagamenti cesseranno.', // Please approve the closing of this account...
            expiration: (date, days) => {
                return `Il tuo account di prova terminerà tra <b>${days}</b> giorni il ${date}.<br/>Iscriviti al piano premium EZtrade per soli $14.99/mese - UN PREZZO DI LANCIO UNICO!` // Your trial account will end...
            }
        },
        account: {
            labels: {
                systemTheme: 'Colore Sistema', // System color
                lightMode: 'Modalità chiara', // Light mode
                darkMode: 'Modalità scura', // Dark mode
                firstName: 'Nome', // First name
                lsatName: 'Cognome', // Last name
                password: 'Nuova password', // New password
                email: 'Email',
                subscriptionDetails: 'Dettagli Abbonamento', // Subscription details
                cancelSubscription: 'Annulla Abbonamento', // Cancel subscription
                updatePaymentCard: 'Aggiorna metodo di pagamento', // Update payment method
                subscriptionPrice: 'Prezzo Abbonamento', // Subscription price
                nextPayment: 'Data prossimo pagamento' // Next payment date
            },
        },
        notificationLabels: {
            portfolio: 'Notifiche Lista Preferiti', // Portfolio notifications
            breakingNews: 'Ultime News', // Breaking news
            vip: 'VIP',
            oilGas: 'Petrolio e Gas', // Oil & gas
            banks: 'Banche', // Banks
            commodities: 'Materie Prime', // Commodities
            econData: 'Dati Economici', // Economic data
            emailNotifications: 'Notifiche Email', // Email notifications
            browserNotifications: 'Notifiche Browser', // Browser notifications
            soundNotifications: 'Notifiche Audio' // Sound notifications
        },
        notificationPeriodLabels: {
            none: 'Nessuno', // None
            realTime: 'Tempo Reale', // Real-time
            five_min: 'Ogni 5 minuti', // Every 5 minutes
            fifteen_min: 'Ogni 15 minuti', // Every 15 minutes
            thirty_min: 'Ogni 30 minuti', // Every 30 minutes
            fortyfive_min: 'Ogni 45 minuti', // Every 45 minutes
            sixty_min: 'Ogni ora' // Every hour
        }
    },
    symbolPage: {
        moreStocks: 'Azioni che potrebbero interessarti', // Stock you maybe interested in
        findMoreStocks: 'Trova azioni interessanti', // Find interesting stocks
        findMoreStocksText: (symbol) => `Trova azioni interessanti correlate a <b>${symbol}</b> in base alla performance e a una Cap. di Mercato simile.`, // Find interesting stocks related to [symbol]...
        clickToFindMoreStocks: 'Clicca qui per trovare altre azioni', // Click here to find more stocks
        performanceOverTime: 'Variazione di prezzo nel tempo', // Price change over time
        epsNote: 'La differenza tra l\'EPS, calcolato sulla nostra pagina azionaria, così come sulla maggior parte degli altri siti web finanziari, può essere dovuta al fatto che la pagina azionaria si riferisce all\'utile contabile, che include spese e ricavi una tantum non rappresentativi a giudizio della direzione della società. Mentre la performance della società di solito mostra l\'"utile rettificato", cioè senza le spese e i ricavi una tantum, come definito dalla direzione della società', // The difference between the EPS...
        pe: 'P/E',
        eps: 'EPS',
        nextEarnings: 'Data prossimi utili', // Next earnings date
        releaseTime: 'Ora di rilascio', // Release time
        estimatedEps: 'EPS stimato', // Estimated EPS
        nextDividend: 'Prossimo dividendo', // Next dividend
        ma50: 'MA50', // MA50
        ma200: 'MA200', // MA200
        ema20D: 'EMA20', // EMA20
        sma50D: 'SMA50', // SMA50
        sma200D: 'SMA200', // SMA200
        volumeTrend: 'Tendenza Volume 5G', // 5D Volume trend
        below: 'sotto', // below
        above: 'sopra', // above
        fiftyTwoWeeksHigh: 'Max 52S', // 52W high (Shorthand)
        fiftyTwoWeeksLow: 'Min 52S', // 52W low (Shorthand)
        yearlyRange: 'Range Annuale', // Yearly range
        atrTrend: 'Tendenza ATR', // ATR trend
        atrPercent: 'ATR%', // ATR%
        relVol: 'Vol. Rel.', // Rel. volume (Shorthand: Volume Relativo)
        rsi: 'RSI', // RSI
        macd: 'MACD', // MACD
        obvTrend: 'Tendenza OBV', // OBV trend
        exDate: 'Data Stacco', // Ex-Date
        paymentDate: 'Data Pagamento', // Payment date
        nextSplitDate: 'Data Prossimo Split', // Next split date
        splitRatio: 'Rapporto Split', // Split ratio
        name: 'Nome Azienda', // Company name
        about: 'Informazioni sull\'azienda', // About the company
        marketCap: 'Cap. Mkt.', // Market cap (Shorthand)
        volume: 'Volume',
        unusualVolume: 'Sopra la media', // Above avg.
        avgVolume: 'Vol. Medio', // Avg. volume (Shorthand)
        price: 'Prezzo',
        symbol: 'Simbolo',
        sector: 'Settore',
        industry: 'Industria',
        sharesOutstanding: 'Azioni in Circolazione', // Shares outstanding
        dailyRange: 'Range Giornaliero', // Daily range
        fiftyTwoWeeks: '52 Settimane', // 52 weeks
        previousClose: 'Chiusura Precedente', // Previous close
        TYRevenueChange: 'Var. Ricavi 3A', // 3Y revenue change
        TYEPSChange: 'Var. EPS 3A', // 3Y EPS change
        tabs: {
            overview: 'Panoramica', // Overview
            news: 'Notizie', // News
            chart: 'Grafico', // Chart
            financials: 'Dati Finanziari', // Financials
            performance: 'Performance',
            insiders: 'Insider' // Insiders
        }
    },
    chart: {
        periods: {
            '1d': '1G', // 1D
            '5d': '5G', // 5D
            '10d': '10G', // 10D
            '1m': '1M', // 1M
            '6m': '6M', // 6M
            'ytd': 'YTD', // YTD
            '1y': '1A', // 1Y
            '3y': '3A', // 3Y
            '5y': '5A', // 5Y
            'max': 'Max' // Max
        },
        ma: 'Medie Mobili', // Moving Averages
        indexCompare: 'Compara Indice', // Compare index
        tooltip: {
            change: 'Variazione', // Change
            volume: 'V', // V
            open: 'A', // O (Apertura)
            close: 'C', // C (Chiusura)
            high: 'H', // H (Massimo)
            low: 'L', // L (Minimo)
            price: 'Prezzo' // Price
        }
    },
    financials: {
        note: 'Il filtro mensile mostra la variazione rispetto al trimestre precedente, mentre il filtro annuale mostra la variazione rispetto allo stesso trimestre dell\'anno precedente.', // The monthly filter displays the change from the previous quarter...
        periodChange: 'Var. % Periodo', // Change %
        yoy: 'A/A', // YoY (Anno su Anno)
        quarterly: 'Trimestrale',
        incomeStatement: 'Conto Economico', // Income statement
        balanceSheet: 'Stato Patrimoniale', // Balance sheet
        cashFlowStatement: 'Rendiconto Finanziario', // Cash flow statement (IT: Flusso di Cassa)
        revenue: 'Ricavi', // Revenue
        operatingExpenses: 'Spese Operative', // Operating expenses
        netIncome: 'Utile Netto', // Net income
        netProfitMargin: 'Margine di Profitto Netto', // Profit margin
        eps: 'EPS',
        ebitda: 'EBITDA',
        cashAndShortTermInvestment: 'Cassa e Investimenti Breve Termine', // Cash and short-term investment
        totalAssets: 'Totale Attività', // Total assets
        totalLiabilities: 'Totale Passività', // Total liabilities
        totalEquity: 'Patrimonio Netto Totale', // Total equity
        operatingCashFlow: 'Flusso di Cassa Operativo', // Operating cash flow
        netCashFromInvesting: 'Flusso Netto da Investimento', // Net cash from investing
        netCashFinancing: 'Flusso Netto da Finanziamento', // Net cash from financing
        netChangeInCash: 'Var. Netta in Cassa', // Net cash change
        freeCashFlow: 'Flusso di Cassa Libero' // Free cash flow (Shorthand: F.C.L.)
    },
    insiders: {
        note: 'Le transazioni azionarie degli insider possono segnalare un segnale positivo O negativo. ' +
            'L\'ACQUISTO da parte degli insider può segnalare fiducia nelle prospettive future dell\'azienda. ' +
            'La VENDITA da parte degli insider (in quantità significativa) può segnalare o essere interpretata come una perdita di fiducia.', // Insider stock transction can signal...
        filingDate: 'Data Deposito', // Filing date
        owner: 'Nome',
        role: 'Ruolo',
        date: 'Data',
        transaction: 'Transazione',
        cost: 'Costo',
        shares: '# Azioni', // # shares
        value: 'Costo Totale', // Total cost
        ownedShares: 'Azioni Possedute Totali', // Total shares
        ownershipWorth: 'Valore Totale della Partecipazione', // Total ownership worth
        ownershipRatio: 'Rapporto di Partecipazione', // Ownership ratio
        totalBuyTransactions: '# Transazioni Acquisto', // # buy transactions
        totalSellTransactions: '# Transazioni Vendita', // # sell transactions
        clickToWatchLink: 'Clicca per vedere il deposito', // Click to see the filing
        link: 'Link',
        reportedAtDate: 'Data Deposito', // Filing date
        transactions: {
            sell: 'Vendita', // Sell
            buy: 'Acquisto', // Buy
            option: 'Esercizio Opzioni', // Options exercise
            award: 'Premio', // Award
            gift: 'Regalo', // Gift
            tax: 'Tassa/Pagamento esercizio' // Tax/exercise payment
        }
    },
    trendingStocks: {
        symbol: 'Simbolo',
        name: 'Nome',
        price: 'Prezzo',
        sectorIndustry: 'Industria',
        ratingChange: 'Variazione Rating', // Rating change
        numberOfMentions: 'N. di Menzioni', // Num. of mentions
        priceChange: 'Var. %', // Change %
        toTheFullList: 'Vedi la lista completa', // See the full list
        label: 'In Tendenza sui Social' // Trending on social media
    },
    dailyBrief: {
        title: 'Cosa Dovresti Sapere Oggi', // You should know today
        explanation: 'Informazioni intra-day e pre-mercato che dovresti conoscere', // Intra-day and pre-market information...
        indices: {
            title: 'Top Indici', // Top indices
            usa: 'USA',
            europe: 'Europa',
            commodities: 'Materie Prime', // Commodities
            asia: 'Asia',
            crypto: 'Criptovalute' // Crypto
        },
        selectedEarnings: {
            weeklyEarningsTitle: 'Utili Selezionati questa settimana', // Selected earnings this week
            dailyEarningsTitle: 'Utili Selezionati oggi', // Selected earnings today
            seeAllEarnings: 'Clicca per vedere tutti gli utili', // Click to see all earnings
            symbol: 'Simbolo',
            reportTime: 'Ora Report' // Report time
        },
        selectedEvents: {
            title: 'Eventi Giornalieri Selezionati', // Selected daily events
            name: 'Nome',
            datetime: 'Data e Ora', // Date & time
            prev: 'Prec.', // Prev. (Precedente)
            est: 'Stima', // Est. (Stimato)
            weeklyEventsTitle: 'Eventi Settimanali Selezionati', // Selected weekly events
            dailyEventsTitle: 'Eventi Giornalieri Selezionati', // Selected daily events
            noEvents: 'Nessun evento da visualizzare', // No events to see
            date: 'Data',
            time: 'Ora' // Time
        }
    },
    topTen: {
        proTitle: 'Performance del Mercato', // Market performance
        title: 'Top 10 Azioni', // Top 10 stocks
        gainers: 'Guadagnanti', // Gainers
        losers: 'Perdenti', // Losers
        active: 'Attivi', // Active
        nasdaq: 'Nasdaq',
        sp: 'S&P500',
        market: 'Intero Mercato', // Entire market
        microCap: 'Micro-Cap ( < $250M)',
        smallCap: 'Small-Cap ($250M - $2B)',
        midCap: 'Mid-Cap ($2B - $10B)',
        largeCap: 'Large-Cap ($10B - $200B)',
        megaCap: 'Mega-Cap ( > $200B)',
        sectors:
            {
                'Communication Services': 'Servizi di Comunicazione',
                'Consumer Cyclical': 'Beni di Consumo Ciclici', // Consumer Cyclical
                'Energy': 'Energia',
                'Financial Services': 'Servizi Finanziari',
                'Real Estate': 'Immobiliare', // Real Estate
                'Technology': 'Tecnologia',
                'Basic Materials': 'Materiali di Base', // Basic Materials
                'Industrials': 'Industriali',
                'Utilities': 'Servizi Pubblici', // Utilities
                'Consumer Defensive': 'Beni di Consumo Difensivi', // Consumer Defensive
                'Healthcare': 'Sanità' // Healthcare
            }

    },
    sectors: {
        title: 'Performance dei Settori', // Sectors performance
        marketValue: 'Val. Mkt.', // Mkt value (Shorthand)
        sharesNumber: '# Azioni', // Shares #
        sectorRatio: '% del Settore', // % of sector
        changeP: 'Var. %', // Change %
        volume: 'Volume',
        marketCap: 'Cap. Mkt.', // Market Cap. (Shorthand)
        pe: 'P/E',
        performance: 'Performance nel Tempo', // Performance over time
        daily: 'Ultima Var. % Giornaliera' // Last daily % change
    },
    calendars: {
        noData: 'Nessun dato trovato', // No data was found
        selection: {
            earnings: 'Utili', // Earnings
            splits: 'Split', // Splits
            ipos: 'IPO',
            dividends: 'Dividendi' // Dividends
        },
        headers: {
            symbol: 'Simbolo',
            reportTime: 'Ora Report', // Report time
            eps: 'EPS',
            date: 'Data',
            dividend: 'Dividendo',
            exDate: 'Data Stacco', // Ex-date
            payableDate: 'Data Pagamento', // Payable date
            ratio: 'Rapporto', // Ratio
            sharesOffered: 'Azioni Offerte', // Shares offered
            ipoPrice: 'Prezzo IPO', // IPO price
            sharesValue: 'Valore Azioni', // Shares value
            exchange: 'Borsa' // Exchange
        },
        dates: {
            lastWeek: 'Settimana scorsa', // Last week
            past7Days: 'Ultimi 7 giorni', // Past 7 days
            yesterday: 'Ieri', // Yesterday
            today: 'Oggi', // Today
            tomorrow: 'Domani', // Tomorrow
            thisWeek: 'Questa settimana', // This week
            next7Days: 'Prossimi 7 giorni', // Next 7 days
            nextWeek: 'Prossima settimana', // Next week
            thisMonth: 'Questo mese', // This month
            nextMonth: 'Prossimo mese' // Next month
        },
        labels: {
            all: 'Tutti', // All
            myWatchlistOnly: 'Solo Lista Preferiti', // Watchlist only
            preMarket: 'Pre-Mercato', // Pre-Market
            afterMarket: 'Dopo-Mercato' // After-Market
        }
    },
    dividends: {
        symbol: 'Simbolo',
        name: 'Nome',
        lastDivAmount: 'Ultimo Div. $', // Last Div. $
        lastDivPayoutDate: 'Data ultimo pagam. div.', // Last div. payout date
        lastDivExDate: 'Data ultimo stacco div.', // Last div. Ex-date
        nextDivAmount: 'Prossimo Div. $', // Next div. $
        nextDivPayoutDate: 'Data prossimo pagam. div.', // Next div. payout date
        nextDivExDate: 'Data prossimo stacco div.', // Next div. Ex-date
        consecutiveYears: 'Anni cons. di pagam.', // Consecutive years pay (Shorthand)
        consecutiveYearsGrowth: 'Anni cons. di crescita', // Consecutive years growth (Shorthand)
        industry: 'Industria',
        sector: 'Settore',
        marketCap: 'Cap. Mkt.', // Market cap. (Shorthand)
        oneYearGrowth: 'Crescita dividendo 1A', // 1Y dividend growth
        threeYearGrowth: 'Crescita dividendo 3A', // 3Y dividend growth
        fiveYearGrowth: 'Crescita dividendo 5A', // 5Y dividend growth
        tenYearGrowth: 'Crescita dividendo 10A', // 10Y dividend growth
        payoutRatio: 'Rapporto Payout', // Payout ratio
        payoutFrequency: 'Frequenza Payout', // Payout frequency
        yield: 'Rendimento' // Yield
    }
}